import {
  ArrayField,
  Datagrid,
  FunctionField,
  ResourceComponentProps,
  TextField,
  useDataProvider,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { CustomDataProvider } from "../../../../network/DataProvider";
import { useEffect, useState, useMemo } from "react";
import { MachineDefinitionGroup } from "./models";
import { MachineDefinitionTelemetryGroupCreate } from "./MachineDefinitionTelemetryGroupCreate";
import { ConfirmDialog } from "../../../components/ConfirmDialog";
import { MachineDefinitionTelemetryGroupEdit } from "./MachineDefinitionTelemetryGroupEdit";

export const MachineDefinitionTelemetryGroupShow = (props: ResourceComponentProps) => {
  const recordContext = useRecordContext(props);
  const dataProvider = useDataProvider<CustomDataProvider>()
  const refresh = useRefresh();

  const [groups, setGroups] = useState<MachineDefinitionGroup[]>([]);

  useEffect(() => {
    dataProvider.getMachineGroups(recordContext.id)
      .then(({ data }) => {
        setGroups(data);
      })
  }, [recordContext, dataProvider]);

  const recordWithGroups = useMemo(() => ({ ...recordContext, groups }), [recordContext, groups]);

  if (!recordContext) return null;

  return (
    <>
      <MachineDefinitionTelemetryGroupCreate {...props} />
      <ArrayField record={recordWithGroups} source="groups" >
        <Datagrid>
          <TextField source="id" label={"id"} />
          <TextField source="name" label={"name"} />
          <TextField source="parentId" label={"parent"} emptyText="-" />
          <FunctionField
            label={""}
            render={(record: any) => {
              return (
                <>
                  <MachineDefinitionTelemetryGroupEdit group={record} {...props} />
                  <ConfirmDialog label={"Delete"} onConfirm={ async () => {
                    await dataProvider.deleteMachineGroup(recordContext.id, record.id)
                    refresh();
                  }} />
                </>
              );
            }}
          />
        </Datagrid>
      </ArrayField>
    </>
  );
}
